import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

import { ref, toRefs, reactive } from "vue";
import dayjs, { Dayjs } from "dayjs";
import type { Rule } from "ant-design-vue/es/form";
import moment from "moment";
import { FormInstance, message } from "ant-design-vue";
import { reducePos } from "@/api/pos";
const dateFormat = "YYYY-MM-DD";
interface FormData {
  endTime: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ReducePosModal',
  props: {
  idTypeDicList: Array,
  planPackageDicList: Array,
  genderDicList: Array,
  bankDicList: Array,
  branchDicList: Array,
  relationDicList: Array,
},
  emits: ["refresh"],
  setup(__props, { expose: __expose, emit: __emit }) {

const open = ref<boolean>(false);
const props = __props;
const emits = __emit;
const {
  idTypeDicList,
  planPackageDicList,
  genderDicList,
  bankDicList,
  branchDicList,
  relationDicList,
} = toRefs(props);
const detailInfo = ref<any>();
const formRef = ref<FormInstance>();
const formdata = reactive<FormData>({
  endTime: "",
});
const rules: Record<string, Rule[]> = {
  endTime: [{ required: true, message: "请选择减保日期" }],
};
const birthDate = ref<Dayjs>();
const startDate = ref<Dayjs>();
const showModal = (record: any) => {
  detailInfo.value = record;
  open.value = true;
};

const handleSubmit = (values: any) => {
  values.endTime = dayjs(values.endTime).format("YYYY-MM-DD");
  values.posId = detailInfo.value.id;
  reducePos(values)
    .then((res: any) => {
      if (res.code == 200) {
        message.success("减保成功");
        emits("refresh");
        open.value = false;
      } else {
        message.error(res.msg);
      }
    })
    .catch();
};
const handleFinishFailed = (errors: any) => {
  console.log(
    "%c [ errors ]-188",
    "font-size:13px; background:pink; color:#bf2c9f;",
    errors
  );
};
__expose({
  showModal,
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[6] || (_cache[6] = ($event: any) => ((open).value = $event)),
      title: "单人减保",
      width: "600px",
      okText: "取消",
      cancelText: "取消",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, _mergeProps({
          ref_key: "formRef",
          ref: formRef,
          model: formdata,
          style: {"width":"400px","margin":"0 auto"}
        }, {
          labelCol: { span: 5 },
          wrapperCol: { span: 16 },
        }, {
          rules: rules,
          onFinish: handleSubmit,
          onFinishFailed: handleFinishFailed
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              name: "insuredName",
              label: "姓名"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.insuredName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((detailInfo.value.insuredName) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "insuredIdType",
              label: "证件类型"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.insuredIdType,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((detailInfo.value.insuredIdType) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idTypeDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "insuredIdNum",
              label: "证件号"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: detailInfo.value.insuredIdNum,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((detailInfo.value.insuredIdNum) = $event)),
                  disabled: true
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "relation",
              label: "人员类别"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.relation,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((detailInfo.value.relation) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relationDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "planPackageId",
              label: "保障方案"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: detailInfo.value.planPackageId,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((detailInfo.value.planPackageId) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(planPackageDicList), (foo) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: foo.code
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(foo.name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "endTime",
              label: "减保日期"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: formdata.endTime,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formdata.endTime) = $event)),
                  placeholder: "",
                  style: {"width":"100%"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { "wrapper-col": { offset: 3, span: 12 } }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  "html-type": "submit",
                  style: {"width":"300px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 16, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})